import { Component, ViewChild, ElementRef, OnDestroy, OnInit, Input } from '@angular/core';
import Highcharts from 'highcharts';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { ESidebarState } from 'src/app/modules/sidebar/enumerables/sidebarState';
import { Subscription } from 'rxjs';
import { DashboardWidgetBasicComponent } from '../dashboard-widget-basic/dashboard-widget-basic.component';
import { delay, tap, takeWhile } from 'rxjs/operators';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { CommunicationService } from 'src/app/services/communication';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';

@Component({
  selector: 'app-dashboard-widget-chart',
  templateUrl: './dashboard-widget-chart.component.html',
  styleUrls: ['./dashboard-widget-chart.component.scss'],
})
export class DashboardWidgetChartComponent extends DashboardWidgetBasicComponent implements OnInit, OnDestroy {
  @ViewChild('chartTarget', { read: ElementRef, static: false })
  public chartTarget: ElementRef;

  protected chart: Highcharts.Chart;
  protected sidebarSubscription: Subscription;

  @Input() chartWidthData: boolean;

  constructor(
    protected progressBarService: BooleanStateService,
    protected communication: CommunicationService,
    protected parameterService: ParameterHandlerService,
    protected sidebarService: StateSidebarService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    protected screenViewService: ScreenViewService,
  ) {
    super(progressBarService, communication, parameterService, cacheService, machineContext, screenViewService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.sidebarService.stateSource
      .pipe(
        delay(200),
        tap((state: ESidebarState) => {
          if (this.chart) {
            this.chart.reflow();
          }
        }),
        takeWhile(() => !this.componentDestroyed),
      )
      .subscribe();
  }

  protected buildView(data: any): void {
    super.buildView(data);
    // if (data) {
    //   this.drawView(data);
    // }
  }

  public drawView(chartOptions: any) {
    this.chart = Highcharts.chart(this.chartTarget.nativeElement, chartOptions as any);
  }

  /**
   * On destroy component
   */
  public ngOnDestroy(): void {
    this.componentDestroyed = true;
    super.ngOnDestroy();
  }
}
